import React, { PureComponent } from 'react';
import styled, { css, ThemeProps } from 'styled-components';
import { FontIconSpan } from '../../components/FontIcon';
import NavigationGroup from '../../components/layout/NavigationGroup';
import {
  Navigation,
  NavigationList,
  NavigationListItem
} from '../../components/Navigation';
import { Section } from '../../components/Section';
import { selectMenu } from '../../provider/Typo3Provider/selectors';
import { MenuEntry } from '../../provider/Typo3Provider/types';
import {
  withTypo3,
  WithTypo3Props
} from '../../provider/Typo3Provider/withTypo3';
import { Theme } from '../../theme';
import { StyledDivComponent } from '../../types';

interface LinksContainerProps {}

interface LinksContainerState {
  showId: number;
  menuEntries: MenuEntry[];
}

const FooterLinks: StyledDivComponent = styled.div`
  background: ${(props: ThemeProps<Theme>) => props.theme.colors.grayDark};
`;

const LinkAccordion: StyledDivComponent = styled.div`
  border-bottom: 1px solid
    ${(props: ThemeProps<Theme>) => props.theme.colors.grayMedium};

  &:last-child {
    border-bottom: 0;
  }
`;

interface LinkAccordionTitleProps {
  open?: boolean;
}

const LinkAccordionTitle = FontIconSpan.extend`
  font-size: 2.2rem;
  padding: 20px 0;
  cursor: pointer;
  display: block;
  position: relative;

  &:before {
    position: absolute;
    right: 0;
    transition: transform 0.2s ease-in-out;

    ${(props: LinkAccordionTitleProps) =>
      props.open &&
      css`
        transform: rotate(-180deg);
      `};
  }
`;

interface LinkAccordionContentProps {
  show?: boolean;
}

const LinkAccordionContent: StyledDivComponent<
  LinkAccordionContentProps
> = styled.div`
  overflow: hidden;
  max-height: ${(props: LinkAccordionContentProps) =>
    props.show ? '500px' : '0'};
  transition: max-height 0.2s linear;

  ${NavigationList} {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    padding-bottom: 20px;
  }

  ${NavigationListItem} {
    margin: 0 0 10px;
    width: 50%;
  }
`;

const getMenuEntries = ({ typo3 }: LinksContainerProps & WithTypo3Props) => {
  return [...selectMenu(typo3, 'footer'), ...selectMenu(typo3, 'locations')];
};

class LinksContainerMobile extends PureComponent<
  LinksContainerProps & WithTypo3Props,
  LinksContainerState
> {
  public state = {
    showId: -1,
    menuEntries: getMenuEntries(this.props)
  };

  public componentDidUpdate(prevProps: LinksContainerProps & WithTypo3Props) {
    // path(Content) changed
    if (prevProps.typo3.pathContent !== this.props.typo3.pathContent) {
      this.setState({
        showId: -1,
        menuEntries: getMenuEntries(this.props)
      });
    }
  }

  public toggleLinks(id: number) {
    this.setState(({ showId }) => ({ showId: showId === id ? -1 : id }));
  }

  public render() {
    const { showId, menuEntries } = this.state;
    return (
      <FooterLinks>
        <Section>
          {menuEntries.map(menuEntry => {
            if (menuEntry.children) {
              const { children, uid } = menuEntry;

              return (
                <LinkAccordion key={uid}>
                  <LinkAccordionTitle
                    onClick={() => this.toggleLinks(uid)}
                    icon="arrow"
                    open={showId === uid}
                  >
                    {menuEntry.title}
                  </LinkAccordionTitle>
                  <LinkAccordionContent show={showId === uid}>
                    <Navigation type='footer'>
                      <NavigationList>
                        <NavigationGroup entries={children} />
                      </NavigationList>
                    </Navigation>
                  </LinkAccordionContent>
                </LinkAccordion>
              );
            }
            return null;
          })}
        </Section>
      </FooterLinks>
    );
  }
}

export default withTypo3(LinksContainerMobile);
